import { loginOrg, loginUser } from '@/utils/LoginContext';
import request from '@/utils/request';

// 查询生鲜拣货任务面板
export async function queryPickerTaskPanel(payload) {
  return request(`/iwms-wms/wms/picktask/queryPickerTaskPanel?dcUuid=${loginOrg().uuid}&pickerUuid=${loginUser().uuid}`, {
    method: 'GET',
  })
}

// 查询摘果任务看板
export async function queryUnPickingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/queryUnPickingTasks`, {
    method: 'POST',
    body: payload
  })
}

// 查询播种任务看板
export async function queryUnSowingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/queryUnSowingTasks`, {
    method: 'POST',
    body: payload
  })
}

// 查询我的摘果任务
export async function queryPickingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/queryPickingTasks`, {
    method: 'POST',
    body: payload
  })
}

// 查询我的摘果任务
export async function querySowingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/querySowingTasks`, {
    method: 'POST',
    body: payload
  })
}

// 获取指令
export async function fetchTask(payload) {
  return request(`/iwms-wms/wms/picktask/fetchTask`, {
    method: 'POST',
    body: payload
  })
}
export async function fetchPickingSowTask(payload) {
  return request(`/iwms-wms/wms/picktask/fetchPickingSowTask`, {
    method: 'POST',
    body: payload
  })
}

// 取消指令
export async function cancelTask(payload) {
  return request(`/iwms-wms/wms/picktask/cancelTask?uuid=${payload}`, {
    method: 'POST',
  })
}

//对当前任务进行拣货-查看详情
export async function getByPsTaskUuid(payload) {
  return request(`/iwms-wms/wms/picktask/getByPsTaskUuid?pickType=${payload.pickType ? payload.pickType : ''}&psTaskUuid=${payload.taskUuid}&taskType=${payload.taskType ? payload.taskType : ''}`, {
    method: 'GET',
  })
}

export async function commit(payload) {
  return request(`/iwms-wms/wms/picktask/commit`, {
    method: 'POST',
    body: payload
  })
}

export async function sowTaskCommit(payload) {
  return request(`/iwms-wms/wms/picktask/sowTaskCommit`, {
    method: 'POST',
    body: payload
  })
}

export async function confirm(payload) {
  return request(`/iwms-wms/wms/picktask/confirm`, {
    method: 'POST',
    body: payload
  })
}

export async function sowTaskConfirm(payload) {
  return request(`/iwms-wms/wms/picktask/sowTaskConfirm`, {
    method: 'POST',
    body: payload
  })
}

export async function verifyPickingContainer(payload) {
  return request(`/iwms-wms/wms/picktask/verifyPickingContainer?containerBarcode=${payload.containerBarcode}&dcUuid=${payload.dcUuid}&pickTaskUuid=${payload.pickTaskUuid}`, {
    method: 'POST'
  })
}

export async function verifySowingContainer(payload) {
  return request(`/iwms-wms/wms/picktask/verifySowingContainer?containerBarcode=${payload.containerBarcode}&dcUuid=${payload.dcUuid}&pickTaskUuid=${payload.pickTaskUuid}`, {
    method: 'POST'
  })
}

export async function verifyPickQty(payload) {
  return request(`/iwms-wms/wms/picktask/verifyPickQty?uuid=${payload.uuid}&pickQty=${payload.pickQty}`, {
    method: 'POST'
  })
}

export async function queryLog(payload) {
  return request(`/iwms-wms/wms/picktask/queryCommitLog`, {
    body: payload,
    method: 'POST'
  })
}

export async function print(payload) {
  return request(`/iwms-wms/wms/picktask/print?commitLogUuid=${payload.commitLogUuid}`, {
    method: 'POST'
  })
}

export async function adjAllocateQty(payload) {
  return request(`/iwms-wms/wms/picktask/adjAllocateQty`, {
    body: payload,
    method: 'POST'
  })
}
